import * as Yup from "yup"

export default function validation_staff_email(field, acc = {}) {
  const { field_name, field_validation } = field
  const isRequired = field_validation?.required?.[0] === "true"
  const isRequiredTxt = field_validation?.required?.[1] || "Required field."

  let schema = Yup.string().email("Invalid e-mail format.")

  if (isRequired) schema = schema.required(isRequiredTxt)

  return {
    [field_name]: schema,
    ...acc,
  }
}
